import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import dayjs from 'dayjs';
import { t } from '@/i18n/i18n';
import template from './DateRange.vue';

@Component({
	mixins: [template]
})
export default class DateRange extends Vue {
	@Prop() value!: any;

	@Prop() loading!: boolean;

	maxDate: string = new Date().toISOString().slice(0, 10);

	menu: boolean = false;

	modalPeriodStart: boolean = false;

	modalPeriodEnd: boolean = false;

	customPeriod: boolean = false;

	periodStart: string = dayjs()
		.format('YYYY-MM-DD')
		.toString();

	periodEnd: string = dayjs()
		.format('YYYY-MM-DD')
		.toString();

	// @ts-ignore
	get innerValue(): {} {
		return this.value;
	}

	// @ts-ignore
	set innerValue(val: any) {
		if (val.custom) {
			this.customPeriod = true;
		} else {
			this.customPeriod = false;
		}
		this.$emit('input', val);
	}

	update(): void {
		this.$emit('update');
	}

	saveCustomStartDate(periodStart: string): void {
		(this.$refs.dialogPeriodStart as any).save(periodStart);
		this.$emit('input', {
			text: t('general.custom'),
			custom: true,
			date: {
				start: dayjs(this.periodStart),
				end: dayjs(this.periodEnd)
			},
			minUnit: 'day'
		});
		this.update();
	}

	saveCustomEndDate(periodEnd: string): void {
		(this.$refs.dialogPeriodEnd as any).save(periodEnd);
		this.$emit('input', {
			text: t('general.custom'),
			custom: true,
			date: {
				start: dayjs(this.periodStart),
				end: dayjs(this.periodEnd)
			},
			minUnit: 'day'
		});
		this.update();
	}

	dateRanges = [
		{
			text: t('general.custom'),
			custom: true,
			date: {
				start: dayjs(),
				end: dayjs()
			},
			minUnit: 'day'
		},
		{
			text: t('general.today'),
			date: {
				start: dayjs(),
				end: dayjs()
			},
			minUnit: 'minute'
		},
		{
			text: t('general.yesterday'),
			date: {
				start: dayjs().subtract(1, 'day'),
				end: dayjs().subtract(1, 'day')
			},
			minUnit: 'minute'
		},
		{
			text: t('general.last-days-count', { days: 7 }),
			date: {
				start: dayjs().subtract(7, 'day'),
				end: dayjs()
			},
			minUnit: 'day'
		},
		{
			text: t('general.last-days-count', { days: 28 }),
			date: {
				start: dayjs().subtract(28, 'day'),
				end: dayjs()
			},
			minUnit: 'day'
		},
		{
			text: t('general.last-days-count', { days: 90 }),
			date: {
				start: dayjs().subtract(90, 'day'),
				end: dayjs()
			},
			minUnit: 'month'
		},
		{
			text: t('general.last-days-count', { days: 180 }),
			date: {
				start: dayjs().subtract(180, 'day'),
				end: dayjs()
			},
			minUnit: 'month'
		},
		{
			text: t('general.last-calender-year'),
			date: {
				start: dayjs()
					.subtract(1, 'year')
					.startOf('year'),
				end: dayjs()
					.subtract(1, 'year')
					.endOf('year')
			},
			minUnit: 'month'
		}
	];

	created() {
		this.innerValue = this.dateRanges[3] as any;
	}

	get dateSubtitle(): string {
		const format = 'DD MMM. YYYY';
		const start = (this.innerValue as any).date.start.format(format);
		const end = (this.innerValue as any).date.end.format(format);
		return `${start} - ${end}`;
	}
}
